import { TemplatePage } from './types';

const thanksgivingDayPage: TemplatePage = {
  header: {
    color: '#C7EDFA',
    icon: 'images/video-templates/thanksgiving.jpg',
    title: 'Thanksgiving Video Templates Collection',
    title_meta: '60+ Free and Customizable Thanksgiving Video Templates',
    description_meta:
      'Kick off the holiday season with Wave.video’s 60+ easy-to-customize Thanksgiving video templates.',
    description:
      'Kick off the holiday season with these easy-to-customize Thanksgiving video templates. Don’t miss out ' +
      'on growth and sales opportunities - create captivating videos that your audience will be grateful for.'
  },
  footer: {
    category: 'Thanksgiving',
    description:
      'Wave.video’s collection of Thanksgiving video templates helps easily create festive marketing videos ' +
      'for your social media, website, email newsletter, or blog. All these templates are easy and free to ' +
      'customize to match your brand.'
  },
  content: [
    {
      type: 'templates',
      title: 'Thanksgiving Video Templates',
      search: {
        category: '/Holidays & Occasions/Thanksgiving'
      }
    },
    {
      type: 'stocks',
      title: 'Thanksgiving',
      search: {
        name: 'thanksgiving'
      }
    },
    { type: 'calendar' }
  ]
} as TemplatePage;

export default thanksgivingDayPage;
